export default "__VITE_ASSET__Cg4sGSU6__"